module.exports = __webpack_public_path__ + "img/diilistirio.db742369.png";